import { render, staticRenderFns } from "./im_content_left.vue?vue&type=template&id=50edd6de&scoped=true&"
import script from "./im_content_left.vue?vue&type=script&lang=ts&"
export * from "./im_content_left.vue?vue&type=script&lang=ts&"
import style0 from "./im_content_left.vue?vue&type=style&index=0&id=50edd6de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50edd6de",
  null
  
)

export default component.exports